(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/pool-betting/aria-utils/assets/javascripts/get-outcome-arialabel-1x2.js') >= 0) return;  svs.modules.push('/components/pool-betting/aria-utils/assets/javascripts/get-outcome-arialabel-1x2.js');
"use strict";


const EventTypeId = svs.components.sportinfo.common.constants.EventTypeId;
const LABELS_1X2 = svs.components.sport.tipsenShared.constants.LABELS_1X2;
const SportTypes = svs.components.sport.sportTypes.SportTypes;
const getOutcomeAriaLabelEventType1X2 = _ref => {
  var _LABELS_1X2$find;
  let sign = _ref.sign;
  if (!sign) {
    return '';
  }
  const ariaLabel1X2 = (_LABELS_1X2$find = LABELS_1X2.find(label => label.text === sign)) === null || _LABELS_1X2$find === void 0 ? void 0 : _LABELS_1X2$find.ariaLabel;
  return ariaLabel1X2;
};
const getOutcomeAriaLabelOverUnder = _ref2 => {
  let sign = _ref2.sign;
  if (!sign) {
    return '';
  }
  let ariaLabelOverUnder;
  if (sign === 'Ö') {
    ariaLabelOverUnder = 'Över';
  } else if (sign === '') {
    ariaLabelOverUnder = 'Ej spelbart alternativ';
  } else if (sign === 'U') {
    ariaLabelOverUnder = 'Under';
  }
  return ariaLabelOverUnder;
};
const getOutcomeAriaLabelH2H = _ref3 => {
  let sign = _ref3.sign,
    homeParticipant = _ref3.homeParticipant,
    awayParticipant = _ref3.awayParticipant;
  if (!sign) {
    return '';
  }
  let ariaLabelH2H;
  if (sign === '1') {
    ariaLabelH2H = "Utfall ett, ".concat(homeParticipant !== null && homeParticipant !== void 0 && homeParticipant.name ? homeParticipant === null || homeParticipant === void 0 ? void 0 : homeParticipant.name : 'alternativ 1', " g\xF6r flest m\xE5l");
  } else if (sign === 'X') {
    ariaLabelH2H = 'Utfall kryss, båda gör lika många mål';
  } else if (sign === '2') {
    ariaLabelH2H = "Utfall tv\xE5, ".concat(awayParticipant !== null && awayParticipant !== void 0 && awayParticipant.name ? awayParticipant === null || awayParticipant === void 0 ? void 0 : awayParticipant.name : 'alternativ 2', " g\xF6r flest m\xE5l");
  }
  return ariaLabelH2H;
};
const getOutcomeAriaLabelWinner = _ref4 => {
  let sign = _ref4.sign,
    homeParticipant = _ref4.homeParticipant,
    awayParticipant = _ref4.awayParticipant;
  if (!sign || !homeParticipant || !awayParticipant) {
    return '';
  }
  let ariaLabelWinner;
  if (sign === '1') {
    ariaLabelWinner = "".concat(homeParticipant ? homeParticipant : 'Alternativ 1', " vinner");
  } else if (sign === '') {
    ariaLabelWinner = 'Ej spelbart alternativ';
  } else if (sign === '2') {
    ariaLabelWinner = "".concat(awayParticipant ? awayParticipant : 'Alternativ 2', " vinner");
  }
  return ariaLabelWinner;
};
const getOutcomeAriaLabelTotalNumberOfGoals = _ref5 => {
  let sign = _ref5.sign;
  if (!sign) {
    return '';
  }
  let ariaLabelTotalNumberOfGoals;
  if (sign !== '+7') {
    ariaLabelTotalNumberOfGoals = "".concat(sign, " m\xE5l");
  } else {
    ariaLabelTotalNumberOfGoals = "7 eller fler m\xE5l";
  }
  return ariaLabelTotalNumberOfGoals;
};
const getOutcomeAriaLabelTrotting = _ref6 => {
  let sign = _ref6.sign;
  if (!sign) {
    return '';
  }
  let ariaLabel1x2Trotting;
  if (sign === 'Övr') {
    ariaLabel1x2Trotting = 'Någon av övriga hästar vinner';
  } else {
    ariaLabel1x2Trotting = "H\xE4st nummer ".concat(sign, " vinner");
  }
  return ariaLabel1x2Trotting;
};
const getOutcomeAriaLabel1X2 = _ref7 => {
  let eventTypeId = _ref7.eventTypeId,
    postfixSymbol = _ref7.postfixSymbol,
    sign = _ref7.sign,
    svenskaFolketValue = _ref7.svenskaFolketValue,
    homeParticipant = _ref7.homeParticipant,
    awayParticipant = _ref7.awayParticipant,
    sportType = _ref7.sportType;
  if (!eventTypeId) {
    return '';
  }
  const isH2H = eventTypeId === EventTypeId.HEAD_TO_HEAD;
  const isTotalNumberOfGoals = eventTypeId === EventTypeId.AMOUNT;
  const isWinner = eventTypeId === EventTypeId.EVENT_1_2;
  const isOverUnder = eventTypeId === EventTypeId.OVER_UNDER;
  const isTrotting = sportType && sportType === SportTypes.Trotting;
  let ariaLabelByEventTypeOrSport;
  if (isTrotting) {
    ariaLabelByEventTypeOrSport = getOutcomeAriaLabelTrotting({
      sign
    });
  } else if (eventTypeId === EventTypeId.EVENT_1X2) {
    ariaLabelByEventTypeOrSport = getOutcomeAriaLabelEventType1X2({
      sign
    });
  } else if (isH2H) {
    ariaLabelByEventTypeOrSport = getOutcomeAriaLabelH2H({
      sign,
      homeParticipant,
      awayParticipant
    });
  } else if (isTotalNumberOfGoals) {
    ariaLabelByEventTypeOrSport = getOutcomeAriaLabelTotalNumberOfGoals({
      sign
    });
  } else if (isWinner) {
    ariaLabelByEventTypeOrSport = getOutcomeAriaLabelWinner({
      sign,
      homeParticipant,
      awayParticipant
    });
  } else if (isOverUnder) {
    ariaLabelByEventTypeOrSport = getOutcomeAriaLabelOverUnder({
      sign
    });
  }
  const ariaLabel = svenskaFolketValue ? "".concat(ariaLabelByEventTypeOrSport, ", Svenska folket ").concat(svenskaFolketValue) : ariaLabelByEventTypeOrSport;
  return postfixSymbol ? "".concat(ariaLabel).concat(postfixSymbol) : ariaLabel;
};
setGlobal('svs.components.poolBetting.ariaUtils.getOutcomeAriaLabel1X2', getOutcomeAriaLabel1X2);

 })(window);